import { render, staticRenderFns } from "./updateAdditionalField.vue?vue&type=template&id=2f72199c&scoped=true"
import script from "./updateAdditionalField.vue?vue&type=script&lang=js"
export * from "./updateAdditionalField.vue?vue&type=script&lang=js"
import style0 from "./updateAdditionalField.vue?vue&type=style&index=0&id=2f72199c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f72199c",
  null
  
)

export default component.exports